import { render, staticRenderFns } from "./PortineriaPortinerieView.vue?vue&type=template&id=4eb283d2&"
import script from "./PortineriaPortinerieView.vue?vue&type=script&lang=ts&"
export * from "./PortineriaPortinerieView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports